import { gql } from "@apollo/client";

export const CMS_CONTENT_BLOCK = gql`
  query CmsContentBlock($identifier: [String!]) {
    cmsBlocks(identifiers: $identifier) {
      items {
        identifier
        content
        __typename
      }
      __typename
    }
  }
`;

export const CMS_CONTENT_PAGE = gql`
  query CmsContentPage($identifier: String!) {
    cmsPage(identifier: $identifier) {
      identifier
      content
      __typename
    }
  }
`;
